import TimePeriod from '@/creditflowresearch/ui/common/components/organisms/TimePeriod';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { TRACE_STORE_NAME } from '@/creditflowresearch/application/Trace/constants';
import FilterSection from '@/creditflowresearch/ui/common/components/organisms/Filters/components/FilterSection';

const filterName = 'tradeTime';
const TimePeriodContainer = ({ sectionId, sectionTitle, isVisible, onSectionToggle, ...props }) => {
  const { getFiltersByFilterName } = useFiltersContext();
  const selectedValue = getFiltersByFilterName(TRACE_STORE_NAME, filterName);

  const onFilterUpdate = (value) => {
    props.handleFilterUpdate({ [props.filterName]: { ...selectedValue, range: { ...value } } });
  };

  return (
    <FilterSection
      sectionId={ sectionId }
      headerComponent={ sectionTitle }
      isVisible={ isVisible }
      onSectionToggle={ onSectionToggle }
    >
      <TimePeriod { ...props } selectedValue={ selectedValue?.range } onFilterUpdate={ onFilterUpdate } />
    </FilterSection>
);
};

export default TimePeriodContainer;
